import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { JsonResourceResponse } from 'app/generated/generated-common';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ShipmentDetailModel } from 'app/generated/backend/shipment/api/shipment-detail-model';
import { ShipmentPackingList } from 'app/generated/backend/shipment/api/shipment-packing-list';

@Injectable()
export class ShipmentPackingListHandlerService {
	private handleError(error: Response | any) {
		return throwError(error);
	}
	constructor(private http: HttpClient) { }
	post(
		number: string,
		request: ShipmentPackingList
	): Observable<JsonResourceResponse<ShipmentDetailModel>> {
		return this.http.post<JsonResourceResponse<ShipmentDetailModel>>(`api/v1/shipment/shipments/${number}/packingList`, request).pipe(
			map(response => response),
			catchError(this.handleError));
	}
}

@NgModule({
	imports: [
		CommonModule
	],
	providers: [
		ShipmentPackingListHandlerService
	]
})
export class ShipmentPackingListHandlerModule { }
